<template>
  <e-charts :options="option"/>
</template>
<script>
import ECharts from 'vue-echarts'
export default {
  name: 'EChartBar',
  components: {
    ECharts
  },
  data () {
    return {
      option: {
        tooltip: {},
        xAxis: {
          type: 'category',
          data: ['江苏', '广东', '浙江', '山东', '安徽'],
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          // offset: -5,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            // inside: true
            padding: [0, -5, 0, 0]
          }
        },
        series: [
          {
            type: 'bar',
            name: '入网企业',
            data: [8293, 7632, 6231, 5623, 6120.12],
            // 柱状的颜色
            itemStyle: {
              color: '#fd8b04'
            }
          },
          {
            type: 'bar',
            name: '生码产品',
            data: [8623.20, 7714.53, 6179.39, 6320.23, 6570.89],
            itemStyle: {
              color: '#3bcafc'
            }
          },
          {
            type: 'bar',
            name: '查询次数',
            data: [4167.9, 3778.3, 3025.6, 2824.6, 3411.39],
            itemStyle: {
              color: '#ff242a'
            }
          }
        ]
      }
    }
  }
}
</script>
